import { apiAxiosCMS } from 'services/api';
import { PriceTagProps } from 'types/PriceTagProps';

export async function createTag(tag: PriceTagProps, handleNotify: any) {
	let isSuccess = false;

	const payload = {
		text: tag.text,
		vtex_cluster_id: tag.vtex_cluster_id,
		vtex_cluster_name: tag.vtex_cluster_name,
		priority: tag.priority,
		color: tag.color,
		background_color: tag.background_color,
		position: tag.position,
		location: tag.location,
		font_size: tag.font_size,
		visible: true,
		file_id: tag.file_id ? tag.file_id : null
	};
	await apiAxiosCMS
		.post('/promotional-tags', payload)
		.then(() => {
			isSuccess = true;
			handleNotify('Etiqueta salva com sucesso', 'success');
		})
		.catch(() => {
			isSuccess = false;
			handleNotify('Ocorreu algum erro ao salvar a etiqueta', 'error');
		});

	return isSuccess;
}

export async function editTag(tag: PriceTagProps, handleNotify: any) {
	let isSuccess = false;

	const payload = {
		text: tag.text,
		vtex_cluster_id: tag.vtex_cluster_id,
		vtex_cluster_name: tag.vtex_cluster_name,
		priority: tag.priority,
		color: tag.color,
		background_color: tag.background_color,
		position: tag.position,
		location: tag.location,
		font_size: tag.font_size,
		visible: tag.visible,
		file_id: tag.file_id ? tag.file_id : null
	};
	await apiAxiosCMS
		.patch(`/promotional-tags/${tag.id}`, payload)
		.then(() => {
			isSuccess = true;
			handleNotify('Etiqueta atualizada com sucesso', 'success');
		})
		.catch(() => {
			isSuccess = false;
			handleNotify('Ocorreu algum erro ao editar a etiqueta', 'error');
		});

	return isSuccess;
}
